define(['moduler'], function (Moduler) {
    'use strict';

    return Moduler.create({
        defaults: {
            triggerElement: 'img,svg',
            pauseTriggerElement: '.cssbox_close',
            videoElement: 'video',
            triggerEvent: 'click'
        },

        init: function () {
            var self = this;

            let targetVideo = self.el.querySelector(self.options.videoElement) ?? self.el.querySelector('video');

            let triggers = self.el.querySelectorAll(self.options.triggerElement) ?? self.el.querySelector('img');

            if (targetVideo) {
                triggers.forEach(trigger => {
                    trigger.addEventListener(self.options.triggerEvent, function (e) {
                        targetVideo.play();
                    });
                });
                if (self.options.pauseTriggerElement) {
                    let pauseTriggers = self.el.querySelectorAll(self.options.pauseTriggerElement);
                    pauseTriggers.forEach(trigger => {
                        trigger.addEventListener(self.options.triggerEvent, function (e) {
                            targetVideo.pause();
                        });
                    });
                }
            }

            // swipe left+right to change image
            self.el.querySelectorAll('.cssbox_full').forEach(box => {
                let prev = box.closest('.cssbox').querySelector('.cssbox_prev');
                let next = box.closest('.cssbox').querySelector('.cssbox_next');
                if (!prev && !next) {
                    return;
                }
                let touchstartX = 0;
                let touchendX = 0;
                box.addEventListener('touchstart', e => {
                    e.preventDefault();
                    touchstartX = e.changedTouches[0].screenX;
                });
                box.addEventListener('touchend', e => {
                    e.preventDefault();
                    touchendX = e.changedTouches[0].screenX;
                    if (next && touchendX < touchstartX - 20) {
                        next.click();
                    } else if (prev && touchendX > touchstartX + 20){
                        prev.click();
                    }
                });
            });

            //close any open box on escape key
            window.addEventListener('keydown', function (e) {
                if (e.key === 'Escape') {
                    let box = document.querySelector('a:target > img.cssbox_thumb + span.cssbox_full');
                    if (box) {
                        box.closest('.cssbox').querySelector('.cssbox_close').click();
                    }
                }
            });
        }
    });
});